import script from "./warning-data-card.vue?vue&type=script&setup=true&lang=js"
export * from "./warning-data-card.vue?vue&type=script&setup=true&lang=js"

import "./warning-data-card.vue?vue&type=style&index=0&id=2adad477&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2adad477"]])

export default __exports__